import { useEffect } from "react";

/**
 * Observes every element with the class "fade-up" and adds
 * the class "visible" when it enters the viewport.
 * A MutationObserver ensures newly added .fade-up elements
 * (e.g. after language switch) are also observed automatically.
 */
const useScrollAnimation = () => {
  useEffect(() => {
    const observed = new WeakSet();

    const intersectionObserver = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("visible");
        }),
      { threshold: 0.1 },
    );

    const observeNew = () => {
      document.querySelectorAll(".fade-up").forEach((el) => {
        if (!observed.has(el)) {
          observed.add(el);
          intersectionObserver.observe(el);
        }
      });
    };

    const mutationObserver = new MutationObserver(observeNew);
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    const timer = setTimeout(observeNew, 120);

    return () => {
      clearTimeout(timer);
      intersectionObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, []);
};

export default useScrollAnimation;
